import {
  section_move_permissions,
  user_new_role_to_old_role,
  stepwise_keys_for_normalization,
} from "./mappings";

export function matchPath(path, key) {
  return path.split("/").includes(key);
}

//for fomatting numbers in indian format
export function formatIndianNumber(num) {
  // Split the number into integer and decimal parts
  const [integerPart, decimalPart] = num.toString().split(".");

  // Format the integer part
  let numStr = integerPart;
  let lastThreeDigits = numStr.slice(-3);
  let otherDigits = numStr.slice(0, -3);

  if (otherDigits !== "") {
    lastThreeDigits = "," + lastThreeDigits;
  }

  let formattedIntegerPart =
    otherDigits.replace(/\B(?=(\d{2})+(?!\d))/g, ",") + lastThreeDigits;

  // Combine the integer part with the decimal part if it exists
  return decimalPart
    ? `${formattedIntegerPart}.${decimalPart}`
    : formattedIntegerPart;
}

// to format "K" (thousands), "M" (millions), and higher notations
export function formatHigherNotationNumber(num) {
  if (num >= 1000000000) {
    return Math.floor(num / 100000000) / 10 + "B"; // Billion
  } else if (num >= 1000000) {
    return Math.floor(num / 100000) / 10 + "M"; // Million
  } else if (num >= 1000) {
    return Math.floor(num / 100) / 10 + "K"; // Thousand
  } else {
    return num.toString(); // Less than thousand, return the number itself
  }
}

// for checking if the string starts with a minus "-" sign
export function startsWithMinusSign(data) {
  return String(data).startsWith("-");
}

// to calculate the number of days between two dates
export function daysBetweenDates(date1, date2) {
  const startDate = new Date(date1);
  const endDate = new Date(date2);

  const differenceInTime = endDate - startDate;

  const differenceInDays = Math.ceil(differenceInTime / (1000 * 3600 * 24));

  return differenceInDays === 1 ? "1 Day" : `${differenceInDays} Days`;
}

export const format_date = (dateString) => {
  if (!dateString) return "-";

  const date = new Date(dateString);
  const day = String(date.getDate()).padStart(2, "0");
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  return `${day} ${month} ${year}`;
};

export const formatPublishedTime = (dateString) => {
  const date = new Date(dateString);

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  let hours = date.getHours();
  const minutes = date.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";

  hours = hours % 12;
  hours = hours ? hours : 12; // the hour '0' should be '12'

  const minutesStr = minutes < 10 ? "0" + minutes : minutes;

  return `${day} ${month} ${year} ${hours}:${minutesStr} ${ampm}`;
};

//to format date (eg: 20-May-2024)
export function formatDate(dateStr) {
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const date = new Date(dateStr);
  const day = date.getDate();
  const month = months[date.getMonth()];
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
}

export function areDatesSame(date1, date2) {
  const d1 = new Date(date1);
  const d2 = new Date(date2);

  return (
    d1.getFullYear() === d2.getFullYear() &&
    d1.getMonth() === d2.getMonth() &&
    d1.getDate() === d2.getDate()
  );
}

export function getFirstDate(dateRange) {
  return dateRange.split(" - ")[0];
}

export function formatDateWithTime(dateValue) {
  const date = new Date(dateValue); // Create a new Date object
  const day = date.getDate();
  const daySuffix = (day) => {
    if (day > 3 && day < 21) return "th"; // handles 11th to 20th
    switch (day % 10) {
      case 1:
        return "st";
      case 2:
        return "nd";
      case 3:
        return "rd";
      default:
        return "th";
    }
  };

  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];

  const year = String(date.getFullYear()).slice(-2); // '24 for 2024
  const hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");
  const ampm = hours >= 12 ? "pm" : "am";

  const formattedHours = hours % 12 || 12; // Convert 24-hour to 12-hour format

  return `${day}${daySuffix(day)} ${
    months[date.getMonth()]
  } '${year} ${formattedHours}:${minutes}:${seconds}${ampm}`;
}

export function formatTime(dateValue) {
  const date = new Date(dateValue);
  if (!(date instanceof Date)) {
    throw new Error("Invalid input: Expected a Date object.");
  }

  // Extract hours and minutes
  let hours = date.getHours();
  const minutes = String(date.getMinutes()).padStart(2, "0");

  // Determine AM/PM
  const ampm = hours >= 12 ? "PM" : "AM";

  // Convert to 12-hour format
  hours = hours % 12 || 12; // Converts 0 (midnight) to 12

  return `${hours}:${minutes} ${ampm}`;
}

export function isAllowedToMoveTask(user, section) {
  // if (user?.is_admin) return true;
  const roles = user?.role || [];
  const allowed_roles = section_move_permissions[section];
  const old_roles_set = new Set();
  for (let role of allowed_roles) {
    const old_roles = user_new_role_to_old_role[role];
    old_roles?.forEach((r) => old_roles_set.add(r));
  }
  for (let role of roles) {
    if (old_roles_set.has(role?.id)) {
      return true;
    }
  }
  return false;
}

export function normalizeAttachments(apiData) {
  const normalized = {};
  Object.entries(apiData).forEach(([platform, items]) => {
    if (!normalized[platform]) normalized[platform] = {};
    items.forEach((item) => {
      const type = item.subcategory; // image, video, reel, audio
      if (!normalized[platform][type]) normalized[platform][type] = [];
      normalized[platform][type].push({
        pk: item.pk,
        url: item.file_urls?.[0] || "",
        status: item.approved_status,
        created_at: item.created_at,
        subcategory: item.subcategory,
        // add more fields if needed
      });
    });
  });
  return normalized;
}

function stringToColor(string) {
  let hash = 0;
  let i;

  /* eslint-disable no-bitwise */
  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = "#";

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }
  /* eslint-enable no-bitwise */

  return color;
}

export function stringAvatar(name) {
  const initials = name
    .split(" ")
    .map((word) => word[0])
    .join("");
  return {
    sx: {
      bgcolor: stringToColor(name),
    },
    children: initials,
  };
}

export function task_history_status_to_color(id) {
  if (id === 5 || id === 16) return "#68C066";
  if (id === 1) return "#1DA1F2";
  if (id === 6) return "#FE5F55";
  if (id === 10 || id === 11) return "#E85D04B3";
  return "#F39237";
}

export function splitAssignedToByType(assigned = []) {
  // const CW_ROLE_IDS = user_new_role_to_old_role.content_writer || [];
  // const DESIGNER_ROLE_IDS = user_new_role_to_old_role.designer || [];

  const content_writer = [];
  const designer = [];
  const approver = [];

  assigned.forEach((u) => {
    if (u.assignee_type === "content_writer") content_writer.push(u);
    else if (u.assignee_type === "designer") designer.push(u);
    else if (u.assignee_type === "approver") approver.push(u);
  });

  return { content_writer, designer, approver };
}

export const taskDataKeyNormalizers = {
  status: (v) => v?.id ?? null,
  project: (v) => v?.id ?? null,
  property: (v) => v?.id ?? null,
  cohort: (v) => v?.id ?? null,
  format: (v) => v?.id ?? null,
  type: (v) => v?.id ?? null,

  approver: (arr) =>
    Array.isArray(arr)
      ? arr
          .map((u) => u?.pk)
          .filter(Boolean)
          .sort()
      : [],
  content_writer: (arr) =>
    Array.isArray(arr)
      ? arr
          .map((u) => u?.pk)
          .filter(Boolean)
          .sort()
      : [],
  designer: (arr) =>
    Array.isArray(arr)
      ? arr
          .map((u) => u?.pk)
          .filter(Boolean)
          .sort()
      : [],

  platform: (arr) =>
    Array.isArray(arr)
      ? arr
          .map((p) => p?.id)
          .filter(Boolean)
          .sort()
      : [],
  selected_pages: normalizeSelectedPagesForApi,

  due_at: (d) => new Date(d),
  schedule_time: (d) => new Date(d),

  title: (v) => v,
  description: (v) => v,
  post_link: (v) => v,
  ig_post_link: (v) => v,
};

export const taskDataDiffByKeys = (oldData, newState, keys = []) => {
  for (const key of keys) {
    const norm = taskDataKeyNormalizers[key] ?? ((v) => v);
    const oldValNorm = norm(oldData?.[key]);
    const newValNorm = norm(newState?.[key]);

    let equal;
    if (oldValNorm instanceof Date && newValNorm instanceof Date) {
      equal = oldValNorm.getTime() === newValNorm.getTime();
    } else if (Array.isArray(oldValNorm) && Array.isArray(newValNorm)) {
      equal =
        oldValNorm.length === newValNorm.length &&
        oldValNorm.every((v, i) => {
          if (typeof v === "object" || typeof newValNorm[i] === "object") {
            return JSON.stringify(v) === JSON.stringify(newValNorm[i]);
          }
          return v === newValNorm[i];
        });
    } else {
      equal = oldValNorm === newValNorm;
    }

    if (!equal) {
      return true;
    }
  }

  return false;
};

export const taskDataDiffByStep = (
  oldData,
  state,
  activeStep,
  stepKeysMap = stepwise_keys_for_normalization,
) => {
  const keys = stepKeysMap?.[activeStep] || [];
  return taskDataDiffByKeys(oldData, state, keys);
};

export const isValidUrl = (urlString) => {
  var urlPattern = new RegExp(
    "^(https?:\\/\\/)?" + // validate protocol
      "((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|" + // validate domain name
      "((\\d{1,3}\\.){3}\\d{1,3}))" + // validate OR ip (v4) address
      "(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*" + // validate port and path
      "(\\?[;&a-z\\d%_.~+=-]*)?" + // validate query string
      "(\\#[-a-z\\d_]*)?$",
    "i",
  ); // validate fragment locator
  return !!urlPattern.test(urlString);
};

const dataURLtoBlob = (dataURL) => {
  const byteString = atob(dataURL.split(",")[1]);
  const mimeString = dataURL.split(",")[0].split(":")[1].split(";")[0];
  const ab = new ArrayBuffer(byteString.length);
  const ia = new Uint8Array(ab);
  for (let i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }
  return new Blob([ab], { type: mimeString });
};

export const dataURLtoFile = (
  dataURL,
  filename = `video_frame_${Date.now()}.jpg`,
) => {
  const blob = dataURLtoBlob(dataURL);
  return new File([blob], filename, { type: "image/jpeg" });
};

export const toDateArray = (input) => {
  const fallback = [new Date(), new Date()];
  if (input == null) return fallback;
  const arr = Array.isArray(input) ? input : [input];
  return arr.map((d) => (d instanceof Date ? d : new Date(d)));
};

export function formatDateYYYYMMDD(date) {
  const d = date instanceof Date ? date : new Date(date);
  const year = d.getFullYear();
  const month = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${year}-${month}-${day}`;
}

export function toTitleCase(str) {
  if (!str) return "";
  return str
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
}

export const normalizeString = (value) =>
  value === null || value === undefined ? "" : value.toString().trim();

export const getDashboardPostPageNames = (record = {}) => {
  const pageValue =
    record.page_name ?? record.page_names ?? record.pages ?? record.page;

  if (Array.isArray(pageValue)) {
    return pageValue
      .map((page) =>
        typeof page === "string" ? page : page?.name ?? page?.page_name,
      )
      .map(normalizeString)
      .filter(Boolean);
  }

  if (pageValue && typeof pageValue === "object") {
    return [pageValue.name ?? pageValue.page_name]
      .map(normalizeString)
      .filter(Boolean);
  }

  return normalizeString(pageValue)
    .split(",")
    .map((page) => page.trim())
    .filter(Boolean);
};

export const formatDashboardPostPageNames = (record) =>
  getDashboardPostPageNames(record).join(", ");

const TASK_PAGE_PLATFORMS = {
  facebook: {
    id: 1,
    suffix: "fb",
    label: "Facebook",
    valueKey: "page_id",
    hasValue: (page) => page?.page_id && page.page_id !== 0,
  },
  instagram: {
    id: 2,
    suffix: "insta",
    label: "Instagram",
    valueKey: "username",
    sourceKey: "instagram_user_name",
    hasValue: (page) =>
      page?.instagram_user_name &&
      page.instagram_user_name !== "0" &&
      page?.instagram_account_name &&
      page.instagram_account_name !== "0",
  },
  youtube: {
    id: 4,
    suffix: "yt",
    label: "YouTube",
    valueKey: "channel_id",
    hasValue: (page) => page?.channel_id && page.channel_id !== "0",
  },
};

const getPagePlatform = (page = {}) => {
  const platform = page.platform ?? page.platform_id;
  const platformId = Number(platform);
  if (platformId === TASK_PAGE_PLATFORMS.facebook.id) return "facebook";
  if (platformId === TASK_PAGE_PLATFORMS.instagram.id) return "instagram";
  if (platformId === TASK_PAGE_PLATFORMS.youtube.id) return "youtube";

  const normalized = platform?.name || platform?.value || platform;
  return normalized?.toString().toLowerCase() || "";
};

const getPlatformValue = (page = {}, platform) => {
  const config = TASK_PAGE_PLATFORMS[platform];
  if (!config) return undefined;
  return page[config.valueKey] ?? page[config.sourceKey];
};

const buildTaskPageOption = (page, property, platform, isBurner = false) => {
  const config = TASK_PAGE_PLATFORMS[platform];
  if (!config?.hasValue(page)) return null;

  const pageValue = getPlatformValue(page, platform);
  const optionOwnerId = isBurner ? page.id : property.id;

  return {
    id: `${optionOwnerId}_${config.suffix}`,
    label: `${page.name}`,
    platform,
    platform_id: config.id,
    page_id: page.page_id,
    username: page.instagram_user_name,
    channel_id: page.channel_id,
    property_id: property.id,
    name: page.name,
    is_burner: isBurner,
    burner_page_id: isBurner ? page.id : null,
    value: pageValue,
  };
};

export const buildTaskPageOptions = (property) => {
  if (!property) return [];

  const options = [];
  const addPageOptions = (page, isBurner = false) => {
    Object.keys(TASK_PAGE_PLATFORMS).forEach((platform) => {
      const option = buildTaskPageOption(page, property, platform, isBurner);
      if (option) options.push(option);
    });
  };

  addPageOptions(property, false);
  (property.burner_pages || []).forEach((page) => addPageOptions(page, true));

  return options;
};

const findMatchingTaskPageOption = (page, property) => {
  if (!property) return null;

  const platform = getPagePlatform(page);
  const incomingValue = getPlatformValue(page, platform);
  return buildTaskPageOptions(property).find(
    (option) =>
      option.platform === platform &&
      getPlatformValue(option, platform)?.toString() ===
        incomingValue?.toString(),
  );
};

export const hydrateSelectedPages = (pages = [], property = null) =>
  (pages || []).map((page) => {
    const matchingOption = findMatchingTaskPageOption(page, property);
    if (matchingOption) return matchingOption;

    const platform = getPagePlatform(page);
    const config = TASK_PAGE_PLATFORMS[platform] || {};
    const isBurner = Boolean(page.is_burner);
    const ownerId = isBurner
      ? page.burner_page_id || page.property_id || page.page_id
      : page.property_id || page.page_id || page.username || page.channel_id;
    const name = page.name || page.label || getPlatformValue(page, platform);

    return {
      id: page.id || `${ownerId}_${config.suffix || platform}`,
      label: page.label || `${name || config.label} - for ${config.label}`,
      platform,
      platform_id: page.platform_id ?? config.id,
      page_id: page.page_id,
      username: page.username ?? page.instagram_user_name,
      channel_id: page.channel_id,
      property_id: page.property_id,
      name,
      is_burner: isBurner,
      burner_page_id: page.burner_page_id ?? null,
      value: page.value ?? getPlatformValue(page, platform),
    };
  });

export function normalizeSelectedPagesForApi(pages = []) {
  return (pages || [])
    .map((page) => {
      const platform = getPagePlatform(page);
      const config = TASK_PAGE_PLATFORMS[platform];
      if (!config) return null;

      const normalizedPage = {
        platform_id: config.id,
      };
      const platformValue = getPlatformValue(page, platform);
      if (!platformValue) return null;

      normalizedPage[config.valueKey] = platformValue;

      return normalizedPage;
    })
    .filter(Boolean)
    .sort((a, b) =>
      `${
        a.platform_id
      }_${a.page_id || a.username || a.channel_id || ""}`.localeCompare(
        `${b.platform_id}_${b.page_id || b.username || b.channel_id || ""}`,
      ),
    );
}

export const formatCohortName = (value) =>
  typeof value === "string" && value.trim() ? value : "-";
